import { Component, OnInit, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { CityModalComponent } from './shared/components/city-modal/city-modal.component';
import { FloatingCityButtonComponent } from './shared/components/city-modal/floating-city-button.component';
import { FloatingWhatsappButtonComponent } from './shared/components/city-modal/floating-whatsapp-button.component';
import { ModalService } from './shared/components/city-modal/services/modal.service';
import { NavComponent } from './shared/components/nav/nav.component';
import { ActiveSaleIndicatorComponent } from './ticket-purchase/components/active-sale-indicator/active-sale-indicator.component';
import { SaleService } from './ticket-purchase/services/sale.service';
import { LocationService } from './utilities/services/location.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NavComponent,
    CityModalComponent,
    FloatingCityButtonComponent,
    FloatingWhatsappButtonComponent,
    ActiveSaleIndicatorComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  public showModal = true;
  public showNav = signal<boolean>(true);

  private router = inject(Router);

  constructor(
    private modalService: ModalService,
    private locationService: LocationService,
    private saleService: SaleService
  ) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.showNav.set(!event.urlAfterRedirects.includes('/auth/login'));
        }
      });

    this.modalService.showModal$.subscribe((show) => (this.showModal = show));

    this.locationService.location$.subscribe((data) => {
      if (!data) {
        this.modalService.toggleModal(true);
      } else {
        this.modalService.toggleModal(false);
        // Inicializar el servicio de ventas una vez que tengamos la ubicación
        this.saleService.initializeService();
      }
    });

    // También inicializar inmediatamente si ya hay ubicación
    if (this.locationService.hasLocation()) {
      this.saleService.initializeService();
    }
  }
}
